import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.boundKeyHandler = this.handleKeydown.bind(this);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeyHandler);
  }

  open(event) {
    event.preventDefault();
    this.modalTarget.classList.add("is-open");
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.boundKeyHandler);
    
    // Focus the first input in the modal
    const firstInput = this.modalTarget.querySelector("input, select");
    if (firstInput) {
      setTimeout(() => firstInput.focus(), 100);
    }
  }

  close(event) {
    if (event) {
      event.preventDefault();
    }
    
    this.modalTarget.classList.remove("is-open");
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.boundKeyHandler);
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close();
    }
  }

  // Handle clicking outside the modal content
  closeOnOverlay(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}